import { CommonUtility } from '../common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Tote extends CRUDService {
  constructor() {
    super(APIPath.containerTotes);
  }

  generateUrl(feedType, params) {
    return BaseService.get(
      `${
        APIPath.containerTotesGenerateUrl
      }/${feedType}?${CommonUtility.objectToParams(params)}`,
    );
  }

  getFeedTemplate(feedType, params) {
    return BaseService.get(
      `${
        APIPath.containerTotesTemplate
      }/${feedType}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  getFeedLogs(params) {
    return BaseService.get(
      `${APIPath.containerTotesFeeds}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  checkLimboState(params) {
    return BaseService.get(
      `${APIPath.containersLimboState}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  resetContainer(data) {
    return BaseService.patch(APIPath.containerReset, data);
  }

  getPreviousLabel(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.totesGenerateLabels}?${query}`);
  }

  bulkCreateTotes(data) {
    return BaseService.post(APIPath.totesBulkCreate, data);
  }

  generateToteLabels(data) {
    return BaseService.post(APIPath.totesGenerateLabels, data);
  }
}

const ToteService = new Tote();
Object.freeze(ToteService);
export { ToteService };
